import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static values = {
    actions: { type: Array, default: [] },
    debounce: { type: Number, default: 300 }
  };

  #debounceTimer;

  execute(event) {
    clearTimeout(this.#debounceTimer);

    this.#debounceTimer = setTimeout(() => {
      const value = event.target.value.trim();
      this.applyActions(this.actionsValue, { value, remove: !value });
    }, this.debounceValue);
  }

  disconnect() {
    clearTimeout(this.#debounceTimer);
  }
}
